import { Component } from '@angular/core';

@Component({
  selector: 'app-carousel-videos',
  templateUrl: './carousel-videos.component.html',
  styleUrls: ['./carousel-videos.component.scss']
})
export class CarouselVideosComponent {

  constructor() { }
}
